export default "__VITE_ASSET__fcf83282__"